import script from "./isReator.vue?vue&type=script&lang=js"
export * from "./isReator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__